module.exports = __webpack_public_path__ + "static/media/aboutimg4.4328ad78.jpg";